import { render, staticRenderFns } from "./ClassFilter.vue?vue&type=template&id=13a19eea&scoped=true&"
import script from "./ClassFilter.vue?vue&type=script&lang=js&"
export * from "./ClassFilter.vue?vue&type=script&lang=js&"
import style0 from "./ClassFilter.vue?vue&type=style&index=0&id=13a19eea&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13a19eea",
  null
  
)

export default component.exports